import { render } from "./FaqLeft.vue?vue&type=template&id=505dbd5c"
import script from "./FaqLeft.vue?vue&type=script&lang=js"
export * from "./FaqLeft.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Asistenca\\old-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__